export default class CreatePaymentForBookingsRequestData {
  public booking_ids: Array<number>
  public promo_code: string | null

  public constructor (bookingIds: Array<number>, promoCode: string | null) {
    this.booking_ids = bookingIds
    this.promo_code = promoCode
  }
}
